export default __webpack_public_path__ + "static/media/medal.427fc6ef.png";